module.exports = __webpack_public_path__ + "images/referenzen/produktfilm/panasonic_leaving_home.jpg";